import { getCertDataField } from '../../../../shared/api/cert/getCertDataField.js';

export function getCertDetail(stepData, enrollform) {
  return [
    {
      children: [
        {
          title: '&nbsp;',
        },
        {
          title: edicom.locale.translate('enrollment.bmcert.label.fechacad'),
          content: stepData.validezhasta,
        },
      ],
    },
    {
      title: `${edicom.locale.translate('enrollment.bmcert.label.name')} ${enrollform.user} (${stepData.numserie})`,
      children: [
        {
          title: edicom.locale.translate('enrollment.bmcert.label.nameCert'),
          content: getCertDataField(stepData.usuario, 'CN'),
        },
        {
          title: edicom.locale.translate('enrollment.bmcert.label.organization'),
          content: getCertDataField(stepData.usuario, 'O'),
        },
        {
          title: edicom.locale.translate('enrollment.bmcert.label.country'),
          content: getCertDataField(stepData.usuario, 'C'),
        },
      ],
    },
    {
      title: `${edicom.locale.translate('enrollment.bmcert.label.ca')} ${getCertDataField(stepData.emisor, 'CN')}`,
      children: [
        {
          title: edicom.locale.translate('enrollment.bmcert.label.organization'),
          content: getCertDataField(stepData.emisor, 'O'),
        },
        {
          title: edicom.locale.translate('enrollment.bmcert.label.country'),
          content: getCertDataField(stepData.emisor, 'C'),
        },
      ],
    },
  ];
}
